import React from 'react'
import '../stylesheets/error.sass'

export const FormError = (props) => {
  return Object.keys(props.errors).length > 0 ?
  (
    <div className={'error'}>
      <div className={'error-text'}>
        <div style={{ margin: 5 }}>
          Something went wrong!
        </div>
        {
          Object.keys(props.errors).map(key => {
            return (
              <div style={{'display': 'inline-block', marginLeft: 5, marginRight: 5 }}>
                <div> { props.errors[key][0] } </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
  : null
}



// WEBPACK FOOTER //
// ./src/shared/FormError.jsx